"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var follow_row_1 = require("./follow_row");
var follows_callout_1 = require("./follows_callout");
var lodash_1 = require("lodash");
var tiles_1 = require("./tiles");
var DEFAULT_CALLOUT_THRESHOLD = 10;
var FollowsList = /** @class */ (function (_super) {
    tslib_1.__extends(FollowsList, _super);
    function FollowsList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FollowsList.prototype.renderCallout = function () {
        if (!this.props.followGroup) {
            return null;
        }
        if (this.props.followGroup.follows.length > this.props.calloutThreshold) {
            return null;
        }
        if (!lodash_1.get(this.props, 'followGroup._links.callout')) {
            return null;
        }
        return (React.createElement(follows_callout_1.default, { actionText: this.props.followGroup.callout_link_text, description: this.props.followGroup.description, actionURL: this.props.followGroup._links.callout.href }));
    };
    FollowsList.prototype.renderFollows = function () {
        var _this = this;
        if (!this.props.followGroup) {
            return null;
        }
        return this.props.followGroup.follows.map(function (follow) {
            return (React.createElement(follow_row_1.default, { actions: _this.props.actions, enableDigestToggle: _this.props.enableDigestToggle, follow: follow, key: follow.id }));
        });
    };
    FollowsList.prototype.renderTitle = function () {
        if (!this.props.followGroup) {
            return null;
        }
        return this.props.followGroup.title;
    };
    FollowsList.prototype.shouldRenderSection = function () {
        if (!this.props.followGroup) {
            return true;
        }
        return !(this.props.followGroup.follows.length === 0
            && !this.props.followGroup.callout_link_text);
    };
    FollowsList.prototype.render = function () {
        if (!this.shouldRenderSection()) {
            return null;
        }
        return (React.createElement("div", { className: "feed-customize__section" },
            React.createElement("h2", { className: "feed-customize__subhead" }, this.renderTitle()),
            React.createElement("div", { className: "feed-customize__tiles" },
                React.createElement(tiles_1.default, { loading: !this.props.followGroup, placeholder: React.createElement(follow_row_1.default, { actions: this.props.actions }) }, this.renderFollows())),
            this.renderCallout()));
    };
    FollowsList.defaultProps = {
        calloutThreshold: DEFAULT_CALLOUT_THRESHOLD,
    };
    return FollowsList;
}(React.Component));
exports.default = FollowsList;
//# sourceMappingURL=follows_list.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/follows_list.js
// module id = aRwf
// module chunks = 0 2 3 20